import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { usePermissions } from "@/modules/auth/presentation/model/usePermissions";
import { dashboardQuickActions } from "../config/quickActions";
import { DashboardSection } from "./DashboardSection";

export function DashboardQuickActions() {
  const { hasAny } = usePermissions();
  const navigate = useNavigate();

  const visible = dashboardQuickActions.filter((item) =>
    hasAny(item.permissionsAny),
  );

  if (visible.length === 0) return null;

  return (
    <DashboardSection title="ການດຳເນີນການດ່ວນ">
    <div className="flex flex-wrap gap-2">
      {visible.map((item) => {
        const Icon = item.icon;
        const isPrimary = item.variant === "primary";
        return (
          <Button
            key={item.url}
            type="button"
            variant={isPrimary ? "default" : "outline"}
            size="sm"
            className="gap-2"
            onClick={() => navigate({ to: item.url })}
          >
            <Icon className="size-4 shrink-0" />
            {item.title}
          </Button>
        );
      })}
    </div>
    </DashboardSection>
  );
}
